import {mapActions, mapGetters} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  data() {
    return {
      loadingCustomers: [],
    };
  },
  computed: {
    ...mapFields("customer", {
      customerIds: "allIds",
      customerIdsCached: "cacheAllIds",
    }),
    ...mapGetters("customer", {
      customerItems: 'list',
      findCustomer: "find",
      customerItemsCached: 'listCache',
    }),
  },
  methods: {
    ...mapActions("customer", {
      retrieveCustomer: "load",
      fetchAllCustomers: 'fetchAll',
    }),
    resolveCustomer(itemId) {
      let itemIri = itemId;
      if (typeof itemIri === 'object' && Object.hasOwn(itemIri, '@id')) {
        itemIri = itemIri['@id'];
      }
      if (itemIri !== null && typeof itemIri !== 'undefined')  {
        if (!this.customerIdsCached.includes(itemIri) && !this.loadingCustomers.includes(itemIri)) {
          this.loadingCustomers.push(itemIri);
          this.retrieveCustomer(decodeURIComponent(itemIri));
        }
        return this.findCustomer(itemIri);
      }
    },
    resolveCustomers(itemIds) {
      if (typeof itemIds === "undefined") {
        return [];
      }
      return itemIds.map((itemId) => {
        return this.resolveCustomer(itemId);
      }).filter(e => e);
    },
    getCustomerItem(customerIri, type) {
      if (customerIri !== null) {
        let customer = this.resolveCustomer(customerIri);
        if (customer) {
          return customer[type];
        }
      }
      return '';
    }
  }
};
